module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-mv.718804f3.png";